import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { GamesFilterCategory } from "@/games/models/games-filter-options";
import { GamesFilterType } from "@/games/models/games-filter-type";
import DsCheckboxOption from "@sazka/design-system/src/forms/components/ds-checkbox-option.vue";
import DsFormGroup from "@sazka/design-system/src/forms/components/general/ds-form-group.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'games-filter-category-options',
  props: /*@__PURE__*/_mergeModels({
    name: {},
    options: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["filterChanged"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const emit = __emit;



const modelValue = _useModel<string[]>(__props, "modelValue");

const filterChanged = (category: GamesFilterCategory) => {
    emit("filterChanged", category);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsFormGroup, {
    theme: "dark",
    name: _ctx.name
  }, {
    default: _withCtx(({ class: itemClass }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createBlock(DsCheckboxOption, {
          key: item.guid,
          class: _normalizeClass([itemClass, "games-filter__checkbox"]),
          value: item.guid,
          label: item.name,
          id: `${_ctx.name}-${item.guid}`,
          name: _ctx.name,
          modelValue: modelValue.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
            () => filterChanged(item)
          ]
        }, null, 8, ["class", "value", "label", "id", "name", "modelValue", "onUpdate:modelValue"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["name"]))
}
}

})